import React, { useContext, useMemo } from "react";
import WebsocketWrapperContext from "../../../context/WebsocketWrapperContext";

const MarketDepth = ({ symbolCode }) => {
  const { symbolData } = useContext(WebsocketWrapperContext);
  const marketData = symbolData[symbolCode] || {};

  // // console.log("sym from ws", symbolData);
  // Extract bid quantities and prices
  const bidQtys = useMemo(
    () => [
      marketData.bq1?.toString() || "0",
      marketData.bq2?.toString() || "0",
      marketData.bq3?.toString() || "0",
      marketData.bq4?.toString() || "0",
      marketData.bq5?.toString() || "0",
    ],
    [marketData]
  );

  const bidPrices = useMemo(
    () => [
      marketData.bp1?.toString() || "0",
      marketData.bp2?.toString() || "0",
      marketData.bp3?.toString() || "0",
      marketData.bp4?.toString() || "0",
      marketData.bp5?.toString() || "0",
    ],
    [marketData]
  );

  // Extract ask prices and quantities
  const askPrices = useMemo(
    () => [
      marketData.sp1?.toString() || "0",
      marketData.sp2?.toString() || "0",
      marketData.sp3?.toString() || "0",
      marketData.sp4?.toString() || "0",
      marketData.sp5?.toString() || "0",
    ],
    [marketData]
  );

  const askQtys = useMemo(
    () => [
      marketData.sq1?.toString() || "0",
      marketData.sq2?.toString() || "0",
      marketData.sq3?.toString() || "0",
      marketData.sq4?.toString() || "0",
      marketData.sq5?.toString() || "0",
    ],
    [marketData]
  );

  // Calculate total bid quantities and ask quantities
  const totalBidQtys = useMemo(
    () => bidQtys.reduce((sum, qty) => sum + (parseInt(qty) || 0), 0),
    [bidQtys]
  );

  const totalAskQtys = useMemo(
    () => askQtys.reduce((sum, qty) => sum + (parseInt(qty) || 0), 0),
    [askQtys]
  );

  const totalQty = totalBidQtys + totalAskQtys;

  const bidPercentage = useMemo(
    () =>
      totalQty !== 0 ? ((totalBidQtys / totalQty) * 100).toFixed(1) : "0.0",
    [totalBidQtys, totalQty]
  );

  const askPercentage = useMemo(
    () =>
      totalQty !== 0 ? ((totalAskQtys / totalQty) * 100).toFixed(1) : "0.0",
    [totalAskQtys, totalQty]
  );

  // If no data is available
  if (Object.keys(marketData).length === 0) {
    return <div className="text-xl font-bold text-p300">No Data Available</div>;
  }

  return (
    <div className="flex flex-col w-full">
      <div className="flex mb-2">
        <div className="flex flex-1 justify-between">
          <span className="text-xs font-normal text-n500">Qty</span>
          <span className="text-xs font-normal text-n500">Bid</span>
        </div>
        <div className="w-2"></div>
        <div className="flex flex-1 justify-between">
          <span className="text-xs font-normal text-n500">Ask</span>
          <span className="text-xs font-normal text-n500">Qty</span>
        </div>
      </div>

      {Array.from({ length: 5 }).map((_, i) => (
        <div key={`depth-row-${i}`} className="flex py-1">
          <div className="flex flex-1 justify-between">
            <span className="text-xs font-medium text-p150">{bidQtys[i]}</span>
            <span className="text-xs font-medium text-p150">
              {bidPrices[i]}
            </span>
          </div>
          <div className="w-2"></div>
          <div className="flex flex-1 justify-between">
            <span className="text-xs font-medium text-red">{askPrices[i]}</span>
            <span className="text-xs font-medium text-red">{askQtys[i]}</span>
          </div>
        </div>
      ))}

      <div className="flex mt-2">
        <div className="flex flex-1 flex-col items-start">
          <span className="text-xs font-medium text-p150">{totalBidQtys}</span>
          <span className="text-xs font-medium text-p150">{`${bidPercentage}% Buy`}</span>
        </div>
        <div className="w-2"></div>
        <div className="flex flex-1 justify-center">
          <span className="text-xs font-normal text-n500">Total quantity</span>
        </div>
        <div className="w-2"></div>
        <div className="flex flex-1 flex-col items-end">
          <span className="text-xs font-medium text-red">{totalAskQtys}</span>
          <span className="text-xs font-medium text-red">{`${askPercentage}% Sell`}</span>
        </div>
      </div>
    </div>
  );
};

export default MarketDepth;
